<template lang="pug">
v-app
  section
    .d-flex.row.flex-row.align-items-end.mb-4
      .col-12
        h2.ps_titulo
          i Resumen Planificación Semanal
    .d-flex.row.flex-row.align-items-end.mb-4
      .col-10
        p.bg-warning.text-center
          | Recuerde que debe finalizar el plan para terminar con el proceso.
      .col-2
        button.stepper-button.next(@click='emitFinish()')
          span Finalizar
    .d-flex.row.flex-row
      .d-flex.pr-0(:class="[(tracings.length > 0) ? activeClass : 'col-7', 'col-5']")
        .card.w-100.mb-0.p-3.ad_border1-secondary.rounded-xl
          h3.mb-3.ad_text-primary
            i Objetivos para la semana
          div(v-if="currentWeekObjectives.length > 0")  
            .col.py-2.rounded-lg.ad_bg-gray.mb-3(v-for="(lwobj, index) in currentWeekObjectives")
              .d-flex.row.form-group.align-items-end.mb-1
                .col
                  a(:id="'provisioncierre' + index")
                    i.icon-letters.icon-letters__viaje.mr-1(v-if="lwobj._id.travel.length > 0") V
                    i.icon-letters.icon-letters__producto.mr-1(v-if="lwobj._id.product.length > 0") P
                    i.icon-letters.icon-letters__segmento.mr-1(v-if="lwobj._id.segment.length > 0") S
                  b-tooltip(:target="'provisioncierre' + index" , placement='top')
                    | {{lwobj._id.travel.length > 0 ? lwobj._id.travel[0].name : ''}}+{{lwobj._id.product.length > 0 ? lwobj._id.product[0].name : ''}}+{{lwobj._id.segment.length > 0 ? lwobj._id.segment[0].name : ''}}
                  a#kpicierre.ml-2
                    i.icon-letters.icon-letters__negocio.mr-1 N
                    | {{lwobj._id.business_type.length > 0 ? lwobj._id.business_type[0].name : ''}}
                .col-auto
                  p.d-inline-block.mb-0.mr-3.ad_text-grayOscuro
                    sup Registro
                    span {{lwobj.objectives[0].businesspercentage}}%
                  p.d-inline-block.mb-0.ad_text-grayOscuro
                    sup Meta
                    span {{lwobj._id.business_type.length > 0 ? lwobj._id.business_type[0].goal : ''}}%
              .d-flex.row
                .col-12
                  table.w-100.text-center.table-rounded-body
                    thead
                      tr
                        th
                        th.text-left Objetivo
                        th Registro
                        th Meta
                        th
                    tbody
                      tr(v-for="(currentwo, n) in lwobj.objectives")
                        td
                          div.pr-0
                            span.num_circle.ad_bg-secondary {{n + 1}}
                        td.text-left
                          div.pl-2
                            | {{ Array.isArray(currentwo.kpi) ? currentwo.kpi.length > 0 ? currentwo.kpi[0].name : 'Sin Kpi' : currentwo.kpi.name}}
                        td
                          div.px-0.justify-content-center
                            | {{currentwo.kpipercentage}}%
                        td
                          div.px-0.justify-content-center
                            | {{currentwo.businesspercentage}}%
                        td
                          div.px-0
                            a.pr-1.no-decoration(href="#" title="Comentarios" @click.stop='openObjDetail(currentwo._id)')
                              i.icono.icono-comentarios.ad_text-primary      
          
      //.-.d-flex.px-3(:class="{'col-4' : (tracings.length > 0)}")
      .d-flex.px-3(:class="[(tracings.length > 0) ? activeClass : 'col-5', 'col-4']")
        .card.w-100.mb-0.p-3.ad_border1-secondary.rounded-xl
          h3.mb-3.ad_text-primary
            i Diálogos de desempeño        
          .col.p-2.rounded-xl.ad_border1-primaryLight.mb-2(v-for="(meet, n) in meetings")
            .row.mb-1
              .col
                span.font-weight-bold.mr-1 {{n + 1}}
                | {{meet.description | truncate( 40, '...')}}
              .col-auto.d-flex.justify-content-between
                span.font-italic  {{moment(meet.date_scheduled).utc().format("DD/MM/YYYY")}}
            .d-flex.flex-row
              .col-12.py-2.ad_bg-gray.rounded-lg
                table.w-100.table-rounded-body
                  thead
                    tr
                      th.px-0(colspan="2") Objetivos
                  tbody
                    tr(v-for="(obj, i) in meet.objectives")
                      td
                        div
                          a.d-flex.flex-nowrap(:id="'viajeddd' + n + i")
                            i.icon-letters.icon-letters__viaje(v-if='obj.travel') V
                            i.icon-letters.icon-letters__producto.mx-1(v-if='obj.product') P
                            i.icon-letters.icon-letters__segmento(v-if='obj.segment') S
                          b-tooltip(:target="'viajeddd' + n + i" , placement='top')
                            | {{(obj.travel) ? obj.travel.name: ''}} + {{(obj.product) ? obj.product.name: ''}} + {{(obj.segment) ? obj.segment.name: ''}}
                          a(:id="'negocioddd' + n + i")
                            i.icon-letters.icon-letters__negocio.ml-1 N
                          b-tooltip(:target="'negocioddd' + n + i" , placement='top')
                            | {{(obj.business_type) ? (obj.business_type.name) ? obj.business_type.name: obj.business_type.length > 0 ? obj.business_type[0].name : '' : ''}}
                          
                          i.icon-letters.icon-letters__kpi.mx-2 A
                          | {{(obj.kpi) ? Array.isArray(obj.kpi) ? obj.kpi.length > 0 ? obj.kpi[0].name : 'Sin Kpi' : obj.kpi.name : 'Sin Kpi'}}
                      td.text-right(valign="top")
                        div
                          a.no-decoration.h3.text-thin(href="#" title="Comentarios" @click.stop='openObjDetail(obj._id)')
                            i.icono.icono-comentarios.ad_text-primary
          
      unless title === null
        .d-flex.col-3.pl-0(v-if='tracings.length > 0')
          .card.w-100.mb-0.p-3.ad_border1-secondary.rounded-xl
            h3.mb-3.ad_text-primary
              i {{title}}
            .row
              .col-12
                table.w-100.table-rounded-body.table-rounded-body_gray
                  thead
                    tr
                      th.font-weight-bold Colaborador
                      th.font-weight-bold.text-right.pr-4 Fecha
                  tbody
                    tr(v-for="tracing in tracings")
                      td
                        div
                          table.w-100
                            tr(v-for="(usr, ind) in tracing.users")
                              td
                                div
                                  | {{usr.name}}
                      td.text-right
                        div
                          | {{ moment(tracing.date).utc().format("DD/MM/YYYY") }}


  v-navigation-drawer(v-model='drawer2', app='', temporary='', right='', width='500')
    header.ad_bg-primary.pt-5.pb-2.px-4
      h3.text-white.mt-4
        i Comentarios
    section.p-4.overflowy-auto
      div(v-if="objective")
        .row.mb-3(v-for='comm in (objective.comments? objective.comments.slice().reverse(): [])')
          .col-4.pr-0
            p.font-weight-bold.m-0 {{comm.user}}
            small.d-block {{comm.date | DateFormat}}
            small.d-block {{comm.date | HourFormat}} hrs.
          .col-8.pl-0
            .dialog-box
              p {{comm.text}}
              div.px-0(v-if="moment(comm.date).week() == moment(plan.date).week()")
                a.no-decoration(href="#" title="Editar" @click.stop='OpenEditCommObj(objective._id, comm._id, comm.text)')
                  i.icono.icon-pencil3.ad_text-primary
    .col-12
      .form-group.justify-content-end
        button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer2 = false")
          i.far.fa-times-circle.fa-1x.mr-1.align-bottom
          | Cancelar
  b-modal(:id='editCommModal.id', centered, modal-class='modal-popUp', title-tag='div',header-class='d-flex', footer-class='d-flex flex-row flex-wrap')
    <template v-slot:modal-title>
      h3.font-weight-bold.mb-0 {{editCommModal.title}}
    </template>
    textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='commentObjectiveEdit')
    <template v-slot:modal-footer="{ ok, cancel, hide }">
      .col-12.d-flex.justify-content-around
          b-button.px-4(size="lg", variant="danger", @click="closeCommentUpdate()")
            | Cancelar
          b-button.px-4(size="lg", variant="success", @click="editCommentObjective()")
            | Editar
    </template>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import Flatpickr from 'vendors/cover/vendors/flatpickr'

export default {
  name: 'Cierre',
  props: ['clickedNext', 'currentStep'],
  components: {
     Flatpickr
  },
  data() {
      return {
        menu: false,
        date: null, 
        cumplimiento: 'cumple',
        drawer2: null,
        overlay: false,
        moveobjetivo: false,
        selectedObjetivo: null,
        selectedColaborador: null,
        currentWeekObjectives: [],
        meetings: [],
        tracings: [],
        comment: '',
        objective: null,
        registroIA: 0,
        title: '',
        editCommModal: {
          id: 'edit-comment',
          title: 'Editar',
          comm_text: '',
          objective_id: null,
          comment_id: null
        },
        commentObjectiveEdit: ''
      }
  },
  methods: {
    moment,
    ...mapActions('objective', [
      'addComment', 'commentsById', 'getObjectiveById', 'getObjectiveByPlan', 'updateObjectComment'
    ]),
    moment,
    ...mapActions('state', [
      'statesList'
    ]),
    ...mapActions('meeting', [
      'getMeetingsByPlanOpen'
    ]),
    ...mapActions('tracing', [
      'getTracingByPlan'
    ]),
    openObjDetail(id) {
      const vm = this              
      vm.getObjectiveById(id).then(() => {        
        vm.objective = vm.$store.getters['objective/getObjective']        
        vm.drawer2 = !vm.drawer2
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    addCommentToObjective(id) {
      const vm = this
      let comm = {
        user: vm.user.name,
        date: moment(),
        text: vm.comment
      }
      vm.addComment({
        id: id,
        comment: comm  
      }).then(() => {
        vm.objective.comments.push(comm)
        vm.drawer2 = false        
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    finish() {
      vm.statesList({order: 1}).then(() => {
        let state = vm.$store.getters['state/getStates']
      })
    },
    emitFinish() {
      this.$parent.$emit('stepper-finished');
    },
    OpenEditCommObj(objective_id, comment_id, comm_text) {
      const vm = this;
      vm.$bvModal.show(vm.editCommModal.id)
      vm.commentObjectiveEdit = comm_text;
      vm.editCommModal.objective_id = objective_id;
      vm.editCommModal.comment_id = comment_id;
    },
    editCommentObjective() {
      const vm = this;
      let data = {
        id:  vm.editCommModal.objective_id,
        comment_id: vm.editCommModal.comment_id,
        text: vm.commentObjectiveEdit
      }
      vm.updateObjectComment(data).then((objective) => {
        vm.objective = objective;
        vm.$bvModal.hide(vm.editCommModal.id);
        vm.drawer2 = !vm.drawer2
      }, (error) => {
        vm.$bvModal.hide(vm.editCommModal.id);
        vm.drawer2 = !vm.drawer2
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      });
    },
    closeCommentUpdate() {
      const vm = this;
      vm.$bvModal.hide(vm.editCommModal.id);
      vm.drawer2 = !vm.drawer2
    }
  },
  watch: {
    moveobjetivo: function(){
      let moveobjetivo = true
      // if(this.moveobjetivo === true) {
      //     this.$emit('can-continue', {value: true});
      //     this.$emit('completed-step', {value: true});
      // } else {
      //     this.$emit('can-continue', {value: false});
      // }
    },
    drawer2 : function() {
      this.$parent.overlay = !this.$parent.overlay
      this.$emit('clase', this.$parent.overlay)
      // console.log(this.$parent.overlay)
      const el = document.querySelector('.overlay')

      if (this.$parent.overlay) {
        el.classList.add('open')
      } else {
        el.classList.remove('open')
      }
    },
  },
  mounted() {
    const vm = this
    const loading = vm.$toast.loading('Cargando...')
    vm.user = vm.$store.getters['auth/getUserInfo']
    vm.plan = vm.$store.getters['plan/getPlan']
    vm.title = (vm.user.profile.auth.tabs.indexOf("confirmacion_procesos") != -1) ?  'Confirmación de Procesos' : (vm.user.profile.auth.tabs.indexOf("seguimiento_diario") != -1) ?  'Seguimientos Diarios' : null
    vm.getObjectiveByPlan({id: vm.plan._id, user: vm.user.id}).then(() => {
      vm.currentWeekObjectives = vm.$store.getters['objective/getObjectives']
      vm.getMeetingsByPlanOpen(vm.plan._id).then(() => {        
        vm.meetings = vm.$store.getters['meeting/getMeetings']
        vm.getTracingByPlan(vm.plan._id).then(() => {
          vm.tracings = vm.$store.getters['tracing/getPTracing']
          if(vm.tracings.length > 0 || vm.title === null) {
            this.$emit('can-continue', {value: true});
          } else {
            this.$emit('can-continue', {value: false});
          }
          loading.hide()      
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    }, (error) => {
      loading.hide()
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: error.payload.message,
        closeable: true,
        duration: 5000
      })
    })
    this.$emit('can-continue', {value: true})
  },
};

</script>

<style lang="stylus">
</style>


// WEBPACK FOOTER //
// src/views/ps-cierre.vue